import Select, { components } from "react-select";


const SingleValue = (props) => {
  return (
    <components.SingleValue {...props}>
      {props.data.title}
    </components.SingleValue>
  );
};

const options = [
  {
    value: "PUBLIC",
    title: "Public",
    label: (
      <div>
        <div style={{ fontWeight: "500" }}>Public</div>
        <div style={{ fontSize: "10px", color: "#666" }}>
          Other Staff in your organisation can see this Collection, as well as
          any Learners or Classes, you’ve shared it with.
        </div>
      </div>
    ),
  },
  {
    value: "PRIVATE_GROUP",
    title: "Share Only",
    label: (
      <div>
        <div style={{ fontWeight: "500" }}>Share Only</div>
        <div style={{ fontSize: "10px", color: "#666" }}>
          Only people you’ve shared this Collection with will be able to see it.
          This applies to both Learners and Staff.
        </div>
      </div>
    ),
  },
  {
    value: "PRIVATE",
    title: "Private",
    label: (
      <div>
        <div style={{ fontWeight: "500" }}>Private</div>
        <div style={{ fontSize: "10px", color: "#666" }}>
          Only you can see this Collection. Private Collections can’t be shared
          with Staff, Learners, or Classes while remaining Private.
        </div>
      </div>
    ),
  },
];

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: "25px",
    border: "2px solid transparent",
    boxShadow: state.isFocused ? "0 0 0 2px #a04de9" : "none",
    backgroundImage:
      "linear-gradient(#e0ebff, #e0ebff), linear-gradient(to right, #9b55f1, #ec3c95)",
    backgroundOrigin: "border-box",
    backgroundClip: "padding-box, border-box",
    paddingLeft: "4px",
    minHeight: "48px",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  }),
  option: (provided, state) => ({
    ...provided,
    padding: "10px",
    backgroundColor: state.isFocused ? "#c6d6ff" : "#e0ebff",
    color: "#333",
    cursor: "pointer",
  }),
  singleValue: (provided) => ({
    ...provided,
    fontWeight: "600",
    color: "#333",
  }),
};

const AccessTypeSelect = ({ formik }) => {
  const handleChange = (selectedOption) => {
    formik.setFieldValue("accessType", selectedOption.value);
  };

  const selected = options.find(
    (option) => option.value === formik.values.accessType
  );

  return (
    <Select
      options={options}
      styles={customStyles}
      components={{ SingleValue }}
      value={selected}
      onChange={handleChange}
      menuPlacement="top"
      onBlur={formik.handleBlur}
      name="accessType"
    />
  );
};

export default AccessTypeSelect;
